export const environment = {
  production: true,
  apiHost: '',
  uploadedHost: '',
  universalApiHost: `https://klondike.com.ua`,
  pagesChangeTopic: 'pages_change',
};
